import { centsToDollar } from "@views/utils"

export const checkAmount = (amount: number, balance: number) => {
    const currentBalance = centsToDollar(balance)
    const MINIMUM_VALID_AMOUNT = 0.01
    if(amount > currentBalance) return { valid: false, message: "Not enough balance." }
    if(amount <= MINIMUM_VALID_AMOUNT) return { valid: false, message: "Invalid amount." }
    return { valid: true }
  }
